import { type ReactElement } from 'react';
import { type StructuredTextGraphQlResponse } from 'react-datocms';
import {
  Button,
  type ButtonProps,
} from '@ironhack/design-system2/components/button';
import { Flex, type FlexProps } from '@ironhack/design-system2/components/flex';

import { CheckboxField } from '@/app/components/client/checkbox-field';
import { StructuredContent } from '@/app/components/client/structured-content';

type Props = {
  buttonProps?: ButtonProps;
  buttonText: string;
  isLoading: boolean;
  legalText: StructuredTextGraphQlResponse;
  newsletterLabel?: string;
  withNewsletter?: boolean;
} & FlexProps;

export const FormSubmit = (props: Props): ReactElement => {
  const {
    buttonProps = {},
    buttonText,
    isLoading,
    legalText,
    newsletterLabel,
    withNewsletter = false,
    ...flexProps
  } = props;

  return (
    <Flex
      alignItems="center"
      direction="column"
      gap={2}
      mt={1}
      w="full"
      {...flexProps}
    >
      {withNewsletter && newsletterLabel && (
        <CheckboxField
          isRequired
          label={newsletterLabel}
          matchCaptcha
          name="newsletter"
          py={1}
        />
      )}
      <Button
        fontSize="l"
        isLoading={isLoading}
        maxW="full"
        px={10}
        size="lg"
        type="submit"
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <StructuredContent
        color="text.secondary"
        data={legalText}
        textAlign="center"
        textStyle="m"
      />
    </Flex>
  );
};
